/**
 * Dos donuts: distribución GI vs etapa Kommo real.
 * @module-isolated analytics-cohort
 */
import { ChartCard, SimplePieChart } from '../../../shared/components/index.js';
import { distToPieRows } from '../utils/filter-cohort.js';

export default function StatePies({ giRows, kommoRows }) {
  const pieGi = distToPieRows(giRows, 8);
  const pieKommo = distToPieRows(kommoRows, 8);
  const giCollapsed = (giRows || []).filter((r) => r && r.count > 0).length > 8;
  const kommoCollapsed = (kommoRows || []).filter((r) => r && r.count > 0).length > 8;

  return (
    <div className="analytics-cohort-pies">
      <ChartCard
        title="Estados GI"
        note={
          giCollapsed
            ? 'Mapeo de Configuración · las menores van a Otros'
            : 'Mapeo de Configuración'
        }
      >
        <SimplePieChart rows={pieGi} emptyText="Sin datos para el mapeo GI." />
      </ChartCard>
      <ChartCard
        title="Estados Kommo"
        note={
          kommoCollapsed
            ? 'Etapa real del embudo · las menores van a Otros'
            : 'Etapa real del embudo, sin mapeo GI'
        }
      >
        <SimplePieChart rows={pieKommo} emptyText="Sin etapas Kommo." />
      </ChartCard>
    </div>
  );
}
